import React, { useEffect } from 'react';
import { Select, MenuItem, Typography, Box, FormControl } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { resolveFieldsService } from '../../apis/EntitiesSelection';

function JoinFunc({
  workflowId,
  updatedConfig,
  sourceField,
  setSourceField,
  sourceEntity,
  setSourceEntity,
  referenceEntity,
  setReferenceEntity,
  referenceField,
  setReferenceField,
  lookupValue,
  setLookupValue,
  selectedFields,
  selectedEntities,
  referenceFields,
  setReferenceFields,
  referenceConnection,
  setReferenceConnection,
  selectedConnections,
}) {
  // const sourceNode = updatedConfig?.nodes?.find(
  //   (node) => node?.config?.type === 'sourceNode',
  // );

   // Get all sourceNodes
const sourceNodes = updatedConfig?.nodes?.filter(
  (node) => node?.config?.type === 'sourceNode',
);
console.log('selectedConnections', selectedConnections);
// Build connection details for dropdowns if needed
const connectionDetails = sourceNodes.map((sourceNode) => ({
  connName: sourceNode?.config?.connection?.conn_name || '',
  connId: sourceNode?.config?.connection?.conn_id || '',
}));

  console.log('conn updatedConfig', updatedConfig);
  console.log('conn sourceNodes', sourceNodes);
  console.log('conn selectedFields', selectedFields);
  console.log('conn selectedEntities', selectedEntities);
  
  useEffect(() => {
    if (Array.isArray(connectionDetails)) {
      if (connectionDetails.length === 1) {
        setReferenceConnection(connectionDetails[0].connId);
      } else if (connectionDetails.length === 0) {
        setReferenceConnection('');
      }
      // when >1 we keep whatever the user picked
    }
  }, [connectionDetails, setReferenceConnection]);

  useEffect(() => {
    if (selectedFields?.length > 0 && !sourceField) {
      setSourceField(selectedFields[0]); // ✅ it's a string now
    }
    if (selectedEntities?.length > 0 && !sourceEntity) {
      setSourceEntity(selectedEntities[0]); // ✅ it's a string now
    }
  }, [selectedFields, selectedEntities, sourceField, sourceEntity]);

  // const sourceKey = `${sourceNode.id}-${sourceNode?.config?.connection?.conn_id || ''}-${
  //   sourceNode?.config?.module || ''
  // }`;
  const sourceKeys = Array.from(
  new Set(
    sourceNodes.map(
      (node) =>
        `${node.id}-${node?.config?.connection?.conn_id || ''}-${node?.config?.module || ''}`
    )
  )
);
  const entitiesByWorkflow = useSelector(
    (state) => state.entities.entitiesByWorkflow,
  );
  const finalConfigPayload = useSelector(
    (state) => state.mapping.finalConfigPayloadByWorkflow?.[workflowId],
  );
  console.log('conn finalConfigPayload:', finalConfigPayload);
  // const entityList = entitiesByWorkflow?.[workflowId]?.[sourceKey] || [];
  let entityList = [];
if (sourceKeys.length === 1) {
  // Single sourceNode
  entityList = entitiesByWorkflow?.[workflowId]?.[sourceKeys[0]] || [];
} else {
  // Multiple sourceNodes
  entityList = sourceKeys.flatMap(
    (key) => entitiesByWorkflow?.[workflowId]?.[key] || []
  );

  // Optional: remove duplicates if entities are identical across multiple keys
  const seen = new Set();
  entityList = entityList.filter((entity) => {
    const id = entity.id || entity.name || JSON.stringify(entity);
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}

  const resolvedData = useSelector(
    (state) => state.mapping.resolvedFieldsByWorkflow?.[workflowId],
  );
  console.log('resolvedData:', resolvedData);

  const referenceEntityOptions = entityList
    .filter(
      (e) =>
        e.entity_name.trim().toLowerCase() !==
        (sourceEntity || '').trim().toLowerCase(),
    )
    .map((e) => ({
      value: e.entity_name,
      label: e.label || e.entity_name,
    }));

  const renderBy = (options) => (val) => {
    if (!val) return '';
    const hit = options.find((o) => o.value === val);
    return hit ? hit.label : String(val);
  };
  const MENU_PROPS = {
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
    marginThreshold: 0,
    PaperProps: {
      sx: {
        maxHeight: 240,
        mt: 0.5,
        minWidth: 0,
        width: '200px',
      },
    },

    MenuListProps: {
      dense: true,
      sx: { py: 0 },
    },
  };

  const StyledSelect = styled(Select)({
    width: '100%',
    fontSize: '0.938rem',
    borderRadius: '4px',
    '& .MuiOutlinedInput-root': {
      height: '40px', // Set fixed height
      borderRadius: '4px',
      paddingRight: '32px',
    },
    '& .MuiSelect-select': {
      padding: '7px 12px',
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.938rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.5)',
    },
  });

  const handleReferenceFieldChange = (e) => {
    setReferenceField(e.target.value);
  };

  const handleReferenceEntityChange = async (e = null) => {
    // const selected = e.target.value;
    const selected = e ? e.target.value : referenceEntity;
    setReferenceEntity(selected);
    setReferenceField('');

    const enrichedPayload = Object.values(finalConfigPayload)
      .filter((n) => n.type === 'source' || n.type === 'sourceNode')
      .map((n) => ({
        ...n,
        selectedEntities: [{ entity_name: selected, label: selected }],
      }));

    if (selected && enrichedPayload.length) {
      try {
        const response = await resolveFieldsService({
          label: 'FieldResolution',
          configs: enrichedPayload,
        });

        const fieldOptionsRaw = Array.isArray(response)
          ? response[0]?.fields?.fields || []
          : [];

        const fieldOptions = fieldOptionsRaw
          .map((f) => ({
            value: f.field_name || f.field_label,
            label: f.field_label || f.field_name,
          }))
          .filter((f) => typeof f.value === 'string');

        setReferenceFields(fieldOptions);
        if (!referenceField && fieldOptions.length) {
          setReferenceField(fieldOptions[0].value);
        } else if (
          referenceField &&
          fieldOptions.some((option) => option.value === referenceField)
        ) {
          // If referenceField already has a value that exists in fieldOptions, retain it
          // Otherwise, set it to the first field option
          setReferenceField(referenceField);
        } // Set the first field as the default
      } catch {
        setReferenceFields([]);
      }
    } else {
      setReferenceFields([]);
    }
  };

  useEffect(() => {
    if (referenceEntity) {
      handleReferenceEntityChange(); // Call the function even when referenceEntity has a value
    }
  }, [referenceEntity]);

  return (
    <>
      <Box mt={1}>
        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Source Entity
          </Typography>
          <StyledSelect
            value={sourceEntity}
            MenuProps={MENU_PROPS}
            onChange={(e) => setSourceEntity(e.target.value)}
          >
            {selectedEntities.map((entity, index) => (
              <MenuItem
                key={index}
                value={entity}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {entity}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Source Field
          </Typography>
          <StyledSelect
            value={sourceField}
            MenuProps={MENU_PROPS}
            onChange={(e) => setSourceField(e.target.value)}
          >
            {selectedFields.map((field, index) => (
              <MenuItem
                key={index}
                value={field}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {field}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        {connectionDetails.length > 1 && (
          <FormControl fullWidth margin="normal">
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Reference Connection
            </Typography>
            <StyledSelect
              value={referenceConnection || ''}
              MenuProps={MENU_PROPS}
              onChange={(e) => setReferenceConnection(e.target.value)}
            >
              {connectionDetails.map((connection, index) => (
                <MenuItem
                  key={index}
                  value={connection.connId}
                  sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
                >
                  {connection.connName}
                </MenuItem>
              ))}
            </StyledSelect>
          </FormControl>
        )}
        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Reference Entity
          </Typography>
          {/* Reference Entity (value = entity_name, label shown) */}
          <StyledSelect
            value={referenceEntity} // stores entity_name
            MenuProps={MENU_PROPS}
            onChange={handleReferenceEntityChange}
            renderValue={renderBy(referenceEntityOptions)}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {referenceEntityOptions.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Reference Field
          </Typography>
          <StyledSelect
            value={referenceField} // stores field_name
            MenuProps={MENU_PROPS}
            // onChange={(e) => setReferenceField(e.target.value)}
            onChange={handleReferenceFieldChange}
            renderValue={renderBy(referenceFields)}
          >
            <MenuItem value="">Select</MenuItem>
            {referenceFields.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Value
          </Typography>
          <StyledSelect
            value={lookupValue}
            MenuProps={MENU_PROPS}
            onChange={(e) => setLookupValue(e.target.value)}
            renderValue={renderBy(referenceFields)}
          >
            <MenuItem value="">Select</MenuItem>
            {referenceFields.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      </Box>
    </>
  );
}

JoinFunc.propTypes = {
  selectedEntities: PropTypes.array.isRequired,
  selectedFields: PropTypes.array.isRequired,
  referenceEntityList: PropTypes.array.isRequired,
  referenceEntity: PropTypes.string.isRequired,
  setReferenceEntity: PropTypes.func.isRequired,
  sourceEntity: PropTypes.string.isRequired,
  setSourceEntity: PropTypes.func.isRequired,
  sourceField: PropTypes.string.isRequired,
  setSourceField: PropTypes.func.isRequired,
  referenceField: PropTypes.string.isRequired,
  setReferenceField: PropTypes.func.isRequired,
  matchonField: PropTypes.string.isRequired,
  setMatchonField: PropTypes.func.isRequired,
  functionTypejoin: PropTypes.string.isRequired,
  setFunctionTypejoin: PropTypes.func.isRequired,
  lookupValue: PropTypes.string.isRequired,
  setLookupValue: PropTypes.func.isRequired,
  referenceFields: PropTypes.array.isRequired,
  setReferenceFields: PropTypes.func.isRequired,
  updatedConfig: PropTypes.object.isRequired,
  workflowId: PropTypes.string.isRequired,
  referenceConnection: PropTypes.string.isRequired,
  setReferenceConnection: PropTypes.func.isRequired,
  selectedConnections: PropTypes.array.isRequired,
};

export default JoinFunc;
